import * as React from 'react';
import { CheckboxGroup, TControlOptions } from '@cian/ui-kit';
import * as styles from './styles.css';
import { RangeQuestion } from '../RangeQuestion';
import { Unit } from './components';

export interface IPriceRangeQuestionProps {
  gteValue: string;
  gteError?: string;
  gtePlaceholder: string;
  lteValue: string;
  ltePlaceholder: string;
  lteError?: string;
  selectedOptions?: string[];
  options?: TControlOptions | null;
  unit?: string | null;
  lteInputName: string;
  gteInputName: string;

  handleChange(e: React.ChangeEvent<HTMLInputElement>): void;

  onSelect?(selected: string[]): void;
}

export const PriceRangeQuestion: React.FC<IPriceRangeQuestionProps> = props => {
  const {
    gteValue,
    gtePlaceholder,
    lteValue,
    ltePlaceholder,
    handleChange,
    onSelect,
    options,
    selectedOptions,
    unit,
    gteError,
    lteError,
    lteInputName,
    gteInputName,
  } = props;

  const handleSelect = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, selected: string[]) => onSelect && onSelect(selected),
    [onSelect],
  );

  return (
    <div>
      <RangeQuestion
        gteValue={gteValue}
        gtePlaceholder={gtePlaceholder}
        gteError={gteError}
        lteError={lteError}
        lteValue={lteValue}
        ltePlaceholder={ltePlaceholder}
        handleChange={handleChange}
        unit={unit && <Unit text={unit} />}
        lteInputName={lteInputName}
        gteInputName={gteInputName}
      />
      {options && !!options.length && (
        <div className={styles['options']}>
          <CheckboxGroup
            disabled={!gteValue && !lteValue}
            options={options}
            onChange={handleSelect}
            value={selectedOptions}
          />
        </div>
      )}
    </div>
  );
};

PriceRangeQuestion.displayName = 'PriceRangeQuestion';
